import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { combineLatest, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { DynamicFeatureFlagService, getAdminHomeUrl, OrganizationType, UserService } from 'shared/services';

@Injectable()
export class RetailerGuard {
    constructor(
        private userService: UserService,
        private auth0Service: AuthService,
        private router: Router,
        private dynamicFeatureFlagService: DynamicFeatureFlagService
    ) {}

    public canActivate() {
        return combineLatest([this.userService.user$, this.auth0Service.user$]).pipe(
            switchMap(([user, auth0User]) => {
                const organizationType = user?.organization?.type || auth0User?.org_type;

                if (!organizationType) {
                    return of(this.router.parseUrl('signup'));
                }

                if (organizationType === OrganizationType.Retailer) {
                    return of(true);
                }

                if (organizationType === OrganizationType.Manufacturer) {
                    return of(this.router.parseUrl('news'));
                }

                if (organizationType === OrganizationType.Admin) {
                    return getAdminHomeUrl(this.dynamicFeatureFlagService).pipe(
                        map((url) => this.router.parseUrl(url.replace(/^\//, '')))
                    );
                }

                return of(false);
            })
        );
    }
}
